var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"water-eval-container"},[_c('div',{staticClass:"head_box"},[_c('div',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"cityGreenLand-charts",attrs:{"id":"cityGreenLand-charts"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }